import { useSelector } from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import { selectSiteUrl, selectFormSecurityToken } from 'core/selectors/app';

export const useSubscribeMember = (props) => {
  const {
    formName = 'UpdateMember',
    endPoint = 'auth.php',
    emailOptions = {},
    customOnUploadProgress = () => {},
    callback = () => {},
  } = props;

  const siteUrl = useSelector(selectSiteUrl);
  const securityToken = useSelector(selectFormSecurityToken);

  const data = {
    form: formName,
    fs: securityToken,
    ...emailOptions,
  };

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
    url: `${siteUrl}/${endPoint}?isAjax=true`,
    onUploadProgress: customOnUploadProgress,
  };

  return () => (axios(options).then(() => callback()));
};
